module.exports = __webpack_public_path__ + "static/FAQ-youtube-b89f867688f2e4cb8c2673477339f60f.jpg";